import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { loadCompanyLogo } from "../utils/companyLogo";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import PageLoading from "./PageLoading";
import "./css/layout.css";

export default function Layout() {
  const location = useLocation();
  const isFinancialReport = location.pathname.startsWith("/report/financial");
  const isTaxReconciliationReport = location.pathname.startsWith("/report/tax-reconciliation");
  const sidebarVariant = isFinancialReport ? "financial" : isTaxReconciliationReport ? "tax-reconciliation" : "default";
  const isReportSidebar = isFinancialReport || isTaxReconciliationReport;

  // Preload the company logo so printed PDFs can include it instantly.
  useEffect(() => {
    void loadCompanyLogo();
  }, []);

  return (
    <>
      <Header />
      <Sidebar variant={sidebarVariant} />
      <main className={`main-content ${isReportSidebar ? "main-content--financial" : ""}`}>
        {/* Keeps header and sidebar in place while a lazily loaded page downloads. */}
        <Suspense fallback={<PageLoading message="Loading page" />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </>
  );
}
